import React, { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";

import CenteredPageContainer from "../layout_components/CenteredPageContainer";
import CenteredLoadingIcon from "../common_components/CenteredLoadingIcon";

import MissionHeader from "./MissionHeader";
import MissionSummary from "./MissionSummary";
import MissionContents from "./mission_contents/MissionContents";

// API Calls
import MissionAPI from "../../api/api_calls/MissionAPI";



function MissionPage(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();
    const navigate = useNavigate();
    const { missionId } = useParams();

    const [mission, setMission] = useState([]);
    const [loadMissionComplete, setLoadMissionComplete] = useState(false);


    const screenWidth = window.innerWidth;
    const isMobile = screenWidth < 840;

    useEffect(() => {
        // Grab information on this user

        async function getMissions() {
            const result = await MissionAPI.show(missionId, navigate);

            if (result.success) {
                setMission(result.mission);
                setLoadMissionComplete(true);
            } else {
                setLoadMissionComplete(false);
            }
        }

        getMissions();
    }, []);



    return (
        <CenteredPageContainer noPadding={isMobile}>
            <div className="mission-page-container">
                {!loadMissionComplete ? <CenteredLoadingIcon /> :
                    <>
                        <MissionHeader mission={mission} />
                        <MissionSummary mission={mission} />
                        <MissionContents mission={mission} />
                    </>
                }
            </div>
        </CenteredPageContainer>
    )
}




export default MissionPage